import Vue from 'vue'
import Layout from '@/layout/Index.vue'
import FddComponents from '@/components'
import FddPackages from '@/packages'
import store from '@/store'
import router from '@/router'
import $api from '@/service/port'
import $config from '@/config'
import $hasRole from '@/utils/role'

import '@/config/option'
import '@/directives'
import '@/filters'
import '@/plugins'
import '@/store'
import '@/constant'
import '@css/common.less'

// 是否生产环境
const { isProd } = $config

// 扩展原型
Object.assign(Vue.prototype, {
  $api,
  $config, // 全局配置
  $hasRole // 权限检查23123
})

/**
 * 非生产环境默认启用开发工具
 * 生产环境运行 localStorage.setItem('fdd-debug', true) 以启用开发工具
 */
if (!isProd || (localStorage && localStorage.getItem('fdd-debug') === 'true')) {
  // 启用开发工具
  Vue.config.devtools = true
}

// 生产提示
Vue.config.productionTip = false

Vue.use(FddComponents)
Vue.use(FddPackages)

new Vue({
  router: router,
  store,
  render: h => h(Layout)
}).$mount('#app')
